import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

import DateFromMillis from '../DateFromMillis';

class PaymentsInfo extends Component {
  schema = {
    foreign_key: 'string',
    adapter: 'string',
    source: 'string',
    ip: 'string',
    coupon_code: 'string',
    type: 'string',
    length: 'int',
    created: 'date',
    amount: 'double',
    recurring_amount: 'double',
    campaign: 'string',
    partner: 'string',
    profit: 'double',
    result: 'boolean',
    automatic: 'boolean',
    recurring: 'boolean',
    paypal_id: 'string',
    updated: 'date',
    original_transaction_id: 'string',
    last_transaction_id: 'string',
    google_play_order_id: 'string',
    purchase_token: 'string',
  };

  columns = [
    {
      id: 'created',
      Header: 'Izveides datums',
      accessor: (d) => get(d.created.$date, '$numberLong', null),
      Cell: ({ value }) => (
        <DateFromMillis millis={value} />
      ),
    },
    {
      Header: 'Lietotāja id',
      accessor: 'foreign_key',
    },
    {
      Header: 'Maksājuma tips',
      accessor: 'adapter',
    },
    {
      Header: 'Cena',
      accessor: 'amount',
    },
    {
      Header: 'Dienu skaits',
      accessor: 'length',
    },
    {
      Header: 'Pirkuma tips',
      accessor: 'type',
    },
    {
      Header: 'Automātiskais maks.',
      accessor: 'result',
    },
    {
      Header: 'Kupona kods',
      accessor: 'coupon_code',
    },
    {
      id: 'updated',
      Header: 'Izveides datums',
      accessor: (d) => get(d.created.$date, '$numberLong', null),
      Cell: ({ value }) => (
        <DateFromMillis millis={value} />
      ),
    },
    {
      Header: 'Kampaņa',
      accessor: 'campaign',
    },
    {
      Header: 'Auto atjaunošanās cena',
      accessor: 'amount',
    },
    {
      Header: 'Avots',
      accessor: 'source',
    },
    {
      Header: 'ip',
      accessor: 'ip',
    },
    {
      Header: 'Partneris',
      accessor: 'partner',
    },
    {
      Header: 'Partneris',
      accessor: 'partner',
    },
    {
      Header: 'Peļņa',
      accessor: 'profit',
    },
    {
      Header: 'paypal_id',
      accessor: 'paypal_id',
    },
    {
      Header: 'original_transaction_id',
      accessor: 'original_transaction_id',
    },
    {
      Header: 'last_transaction_id',
      accessor: 'original_transaction_id',
    },
    {
      Header: 'google_play_order_id',
      accessor: 'google_play_order_id',
    },
  ];

  render() {
    const { payments } = this.props;

    return (
      <div>
        <ReactTable
          getTrProps={(state, rowInfo) => {
            const row = get(rowInfo, 'row', {});
            if (get(row, 'result', null)) {
              return { style: { background: '#90EE90' } };
            }
            return { style: { background: '#FFA07A' } };
          }}
          defaultPageSize={10}
          data={payments}
          columns={this.columns}
        />
      </div>
    );
  }
}

PaymentsInfo.propTypes = {
  payments: PropTypes.instanceOf(Array).isRequired,
};

export default PaymentsInfo;
